import { inject, observer } from "mobx-react";
import React from "react";

// This component will fetch data from store using props storeName & dataSource,
// and will return the wrappedComponent by passing fetched data as props

// Props
// storeName            => name of the store from which data should be fetched (note: DataSourceList file has the list of store & storeVariable name for list of fieldName)
// storeVariable        => name of variable in the store(storeName) which has the data
// wrappedComponent     => component to which this data must be passed
// componentProps       => props to be passed to the wrappedComponent
// store                => has the stores that are injected by mobx-react

const DataSourceWrapper = ({
  storeName,
  storeVariable,
  wrappedComponent,
  componentProps,
  ...stores
}) => {
  const WrappedComponent = wrappedComponent;
  let data = [];
  if (componentProps.options) {
    data = componentProps.options;
  } else {
    data = stores[storeName] ? stores[storeName][storeVariable] : [];
  }
  return <WrappedComponent {...componentProps} data={data} />;
};

export default inject(
  "IBPlanningStore",
  "CommonStore",
  "DispatchStore",
)(observer(DataSourceWrapper));
